module.exports = __webpack_public_path__ + "img/food-fks.b6cd081a.jpeg";